module.exports = __webpack_public_path__ + "img/Illustrator-icon.578f2266.svg";